import React, { memo as Memo } from 'react'
import { Form, DatePicker as BaseDatePicker } from 'antd'
import { useRules } from 'helpers'

const DatePicker = Memo(props => {
	return (
		<Form.Item
			label={props.label}
			name={props.name}
			rules={useRules(props)}
			messageVariables={{ errorKey: props.errorKey || props.label }}>
			<BaseDatePicker
				format={'DD/MM/YYYY'}
				className="input-text"
				{...props.inputOptions}
			/>
		</Form.Item>
	)
})

DatePicker.defaultProps = {
	label: '',
	name: '',
	required: true,
	rules: []
}

export default DatePicker
